import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.marketplace}capabilities`;

export interface GetSellerMarketplaceCapabilitiesQueryArgs {
  sellerId: string;
  marketplace: string;
}

export interface MarketplaceCapabilitiesSummaryDto {
  sellerId: string;
  // Keep the rest of fields flexible until a stricter model is required
  [key: string]: unknown;
}

export const getSellerMarketplaceCapabilitiesRequest = (
  payload: GetSellerMarketplaceCapabilitiesQueryArgs,
): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${payload.sellerId}/${payload.marketplace}`,
  config: { method: SUPPORTED_METHODS.GET },
});

export const getSellerMarketplaceCapabilitiesQuery = async (
  payload: GetSellerMarketplaceCapabilitiesQueryArgs,
): Promise<
  BackResponse<MarketplaceCapabilitiesSummaryDto> | BackResponseFailure
> => {
  try {
    return await executeQuery<BackResponse<MarketplaceCapabilitiesSummaryDto>>(
      getSellerMarketplaceCapabilitiesRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
